import React from 'react';

export type InputProps = {
  id?: string;
  name?: string;
  type?: 'text' | 'email' | 'password' | 'tel' | 'url';
  placeholder?: string;
  autoComplete?: string;
  required?: boolean;
  className?: string;
  label?: string;
  textColor?: string;
};

export const Input = ({
  id,
  name,
  type = 'text',
  placeholder,
  autoComplete,
  required = false,
  className = '',
  label,
  textColor = 'primary-black',
}: InputProps) => {
  const textColorClass = textColor.startsWith('text-') ? textColor : `text-${textColor}`;

  return (
    <>
      {label && (
        <label htmlFor={id} className="sr-only">
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        className={`min-w-0 flex-auto rounded-md bg-white/5 px-3.5 py-2 text-base ${textColorClass} outline-1 -outline-offset-1 outline-gray-700 placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6 dark:bg-white dark:outline-gray-300 dark:placeholder:text-gray-400 dark:focus:outline-indigo-600 ${className}`}
      />
    </>
  );
};
